// @flow
import React, { Component } from 'react';
import { SpacerTab, MobileTabSpacerDiv } from '../../../components/TabStyles';
import NavTabs from '../../../components/NavTabs';
import { StatisticsHeaderDiv } from './StatisticsStyles';
import HeaderTab from '../../../components/HeaderTab';
import { MONTH_SIGNUPS, YEAR_SIGNUPS, TOP_COMMISSIONS } from './reducer';

type Props = {
  activeSection: string,
  setActiveSection: (section: string) => void,
  month: string
};

export default class Header extends Component<Props> {
  componentDidUpdate(prevProps: Props) {
    // trigger moving active tab hr
    if (this.props.activeSection !== prevProps.activeSection) {
      window.dispatchEvent(new Event('resize'));
    }
  }

  render() {
    return (
      <StatisticsHeaderDiv>
        <NavTabs>
          <HeaderTab
            activeSection={this.props.activeSection}
            setActiveSection={this.props.setActiveSection}
            sectionName={`Sign ups ${this.props.month}`}
            sectionValue={MONTH_SIGNUPS}
          />
          <HeaderTab
            activeSection={this.props.activeSection}
            setActiveSection={this.props.setActiveSection}
            sectionName="Sign ups year to date"
            mobileSectionName="Sign ups YTD"
            sectionValue={YEAR_SIGNUPS}
          />
          <HeaderTab
            activeSection={this.props.activeSection}
            setActiveSection={this.props.setActiveSection}
            sectionName={`Top commissions ${this.props.month}`}
            sectionValue={TOP_COMMISSIONS}
          />
          <SpacerTab tablet />
          <MobileTabSpacerDiv />
        </NavTabs>
      </StatisticsHeaderDiv>
    );
  }
}
